import { DEFAULT_DEPARTMENT, normalizeDepartment } from "./departments";

/** Placeholders and helper copy for create/edit forms — keyed by department. */
const FORM_HINTS = {
  "Tech Team": {
    projectName: "e.g. Mobile App Redesign",
    budgetLabel: "Budget Allocated (₹)",
    budgetPlaceholder: "Optional — can be set later",
    startDateHelper: "Optional — defaults to today if not set",
    issueWork: "What needs to be done…",
    sprintName: "e.g. Sprint 4",
    sprintGoal: "What will be delivered this sprint…",
    epicTitle: "Short epic name for the board",
    epicDescription: "Extra context (not shown as the card title)",
  },
  Marketing: {
    projectName: "e.g. Q3 Brand Campaign",
    budgetLabel: "Campaign Budget (₹)",
    budgetPlaceholder: "Optional campaign budget",
    startDateHelper: "Optional — campaign kickoff date",
    issueWork: "Describe the deliverable (email, ad set, landing page…)…",
    sprintName: "e.g. April Campaign Sprint",
    sprintGoal: "What campaigns or deliverables ship this period…",
    epicTitle: "e.g. Summer Product Launch",
    epicDescription: "Campaign brief, channels, target audience…",
  },
  CSM: {
    projectName: "e.g. Enterprise Onboarding Program",
    budgetLabel: "Program Budget (₹)",
    budgetPlaceholder: "Optional program budget",
    startDateHelper: "Optional — program kickoff date",
    issueWork: "Describe the customer success task (onboarding step, renewal, QBR…)…",
    sprintName: "e.g. Q2 Onboarding Sprint",
    sprintGoal: "What customer outcomes or milestones ship this period…",
    epicTitle: "e.g. Acme Corp Go-Live",
    epicDescription: "Account scope, milestones, success criteria…",
  },
  IT: {
    projectName: "e.g. Infrastructure Upgrade",
    budgetLabel: "Budget Allocated (₹)",
    budgetPlaceholder: "Optional — can be set later",
    startDateHelper: "Optional — defaults to today if not set",
    issueWork: "Describe the IT task or rollout step…",
    sprintName: "e.g. Phase 1 — Rollout",
    sprintGoal: "What infrastructure milestones ship this period…",
    epicTitle: "e.g. SSO Integration",
    epicDescription: "Scope, systems affected, rollout notes…",
  },
  HR: {
    projectName: "e.g. Campus Hiring 2026",
    budgetLabel: "Program Budget (₹)",
    budgetPlaceholder: "Optional program budget",
    startDateHelper: "Optional — program start date",
    issueWork: "Describe the HR program task…",
    sprintName: "e.g. Q2 Hiring Push",
    sprintGoal: "What HR initiatives ship this period…",
    epicTitle: "e.g. Engineer Hiring Pipeline",
    epicDescription: "Program scope, roles, timeline…",
  },
};

export function getDepartmentFormHints(department = DEFAULT_DEPARTMENT) {
  const dept = normalizeDepartment(department);
  return FORM_HINTS[dept] || FORM_HINTS[DEFAULT_DEPARTMENT];
}
